import { render, staticRenderFns } from "./SmsSameComponent.vue?vue&type=template&id=6fbc1628&scoped=true&"
import script from "./SmsSameComponent.vue?vue&type=script&lang=js&"
export * from "./SmsSameComponent.vue?vue&type=script&lang=js&"
import style0 from "./SmsSameComponent.vue?vue&type=style&index=0&id=6fbc1628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbc1628",
  null
  
)

export default component.exports